import React, { Fragment } from "react";
import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import StickyNote2Icon from "@mui/icons-material/StickyNote2";
import SaitDialog from "../atomic/SaitDialog";
import SaitButton from "../atomic/SaitButton";
import { useTranslation } from "react-i18next";
import { saitfecoreNs } from "../utils/Constants";

function NoteButton(props) {
	const [openWindow, setOpenWindow] = React.useState(false);
	const { t } = useTranslation(saitfecoreNs);

	return (
		<>
			<Tooltip
				title={
					<>
						<Typography fontSize={14} sx={{ fontWeight: "bold" }}>
							{props.title}:
						</Typography>
						<Typography fontSize={14}>{props.note}</Typography>
					</>
				}
			>
				<Box
					sx={{
						flexGrow: 1,
						display: "inline-flex",
						justifyContent: "center",
					}}
				>
					<IconButton
						onClick={(e) => {
							setOpenWindow(true);
						}}
					>
						<StickyNote2Icon color="primary" />
					</IconButton>
				</Box>
			</Tooltip>
			<SaitDialog
				open={openWindow}
				title={props.title}
				width="xs"
				content={<Typography align="center">{props.note}</Typography>}
				actions={
					<Fragment>
						<Box sx={{ flexGrow: 1 }} />
						<SaitButton text={t("close")} onClick={() => setOpenWindow(false)} />
						<Box sx={{ flexGrow: 1 }} />
					</Fragment>
				}
			/>
		</>
	);
}

/*
	Obbligatori:
		field
	Facoltativi:
		title
		headerName
		width
*/
export default function SaitNotesColumn(props) {
	return {
		headerName: props.headerName || props.title || "",
		field: props.field,
		width: props.width || 45,
		minWidth: 40,
		sortable: false,
		hidden: props.hidden || false,
		// disableColumnMenu: true,
		columnType: "notes",
		display: "flex",
		objmod: props.objmod,
		startPinned: props.startPinned,
		endPinned: props.endPinned,
		renderCell: (params) => {
			let note = params.row[props.field];
			if (note && (!props.conditionalRendering || props.conditionalRendering(params))) {
				return <NoteButton title={props.title} note={note} />;
			}
			return "";
		},
	};
}
